export default __webpack_public_path__ + "static/media/prelaunch_badge.fec3cca9.svg";